// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"643":"a928a047","654":"8947c7d2","657":"7f24685a","788":"69224859"}[chunkId] + ".chunk.js";
};